import $ from 'jquery'

import '../../../scss/app/artists.scss'

const disciplineField = document.getElementById('js-discipline-filter')
if (disciplineField) {
  disciplineField.addEventListener('change', () => {
    location.href = $(disciplineField).val()
  })
}
